import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAfghanistan = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_173)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M17.2174 1.19072C15.6397 0.427875 13.8698 0 12 0C10.1302 0 8.36025 0.427875 6.78262 1.19072L5.73914 12L6.78262 22.8093C8.36025 23.5721 10.1302 24 12 24C13.8698 24 15.6397 23.5721 17.2174 22.8093L18.2609 12L17.2174 1.19072Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.78263 1.19115C2.76872 3.1321 0 7.24252 0 12C0 16.7575 2.76872 20.8679 6.78263 22.8089V1.19115Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.2174 1.19115V22.8089C21.2313 20.8679 24 16.7575 24 12C24 7.24252 21.2313 3.1321 17.2174 1.19115Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9999 7.82611C9.69472 7.82611 7.82605 9.69483 7.82605 12C7.82605 14.3052 9.69477 16.1739 11.9999 16.1739C14.3051 16.1739 16.1738 14.3052 16.1738 12C16.1738 9.69483 14.3052 7.82611 11.9999 7.82611ZM11.9999 14.6087C10.5592 14.6087 9.39125 13.4407 9.39125 12C9.39125 10.5593 10.5592 9.39131 11.9999 9.39131C13.4406 9.39131 14.6086 10.5593 14.6086 12C14.6086 13.4407 13.4407 14.6087 11.9999 14.6087Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9999 10.4348C11.4236 10.4348 10.9564 10.902 10.9564 11.4783V13.0435H13.0434V11.4783C13.0434 10.902 12.5762 10.4348 11.9999 10.4348Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_173",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgAfghanistan;
